(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$state', '$stateParams', 'Auth', '$timeout'];

    function ActivationController($state, $stateParams, Auth, $timeout) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.resetAccount = {};
        vm.success = null;

        vm.login = function () {
            $state.go('login');
        };

        $timeout(function () {
            angular.element('#password').focus();
        });

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({
                    key: $stateParams.key,
                    newPassword: vm.resetAccount.password
                }).then(activateAccount).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function activateAccount() {
            Auth.activateAccount({key: $stateParams.key}).then(function () {
                vm.error = null;
                vm.success = 'OK';
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
